/**
 * Hook to synchronize owner properties with backend
 */

import { useCallback, useState } from 'react';
import { useSnackbarProvider } from 'src/hooks';
import api from '../api';

const useSyncOwnerProperties = (ownerId: string) => {
  const { showSnackbar, VariantType, SnackTypes } = useSnackbarProvider();
  const [isSyncing, setIsSyncing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const syncProperties = useCallback(
    async (propertyIds: string[]) => {
      setIsSyncing(true);
      setError(null);
      try {
        await api.syncOwnerProperties(ownerId, propertyIds);
        showSnackbar(
          VariantType.success,
          'Owner properties synchronized successfully',
          SnackTypes.none
        );
      } catch (err: unknown) {
        const errorMessage =
          err instanceof Error ? err.message : 'Failed to synchronize owner properties';
        setError(errorMessage);
        showSnackbar(VariantType.error, errorMessage, SnackTypes.none);
      } finally {
        setIsSyncing(false);
      }
    },
    [ownerId, showSnackbar, VariantType, SnackTypes]
  );

  return { isSyncing, error, syncProperties };
};

export default useSyncOwnerProperties;
